import {Component} from "preact";
import JWTClient from "../../../../../../services/JWTClient";
import Spinner from "../../../../../common/spinner";
import ConfigService from "../../../../../../services/ConfigService";
import SectionComponent from "../../../../../layout/section-component";
import ToolbarButton from "../../../../../common/toolbar-button";
import BellIcon from 'mdi-preact/BellIcon';
import styles from './styles.scss';
import DropDownMenu from "../../../../../common/dropdown";
import NotificationList from "../notification-list";
import {OutsideClickWrapper} from "../../../../../layout/outside-click-wrapper";
import BackdropCover from "../../../../../common/backdrop-cover";
import NotificationService from "../../../../../../services/NotificationService";
import SimpleBadge from "../../../../../common/simple-badge";
import {translate} from "../../../../../../services/TranslateService";
import ModuleInfoProvider from "../../../../../../services/ModuleInfoProvider";

export default class NotificationsButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: false,
            notifications : [],
            unreadCount: 0,
            open: false
        };
    }

    componentDidMount() {
        this.fetchNotifications();
        NotificationService.start();
        NotificationService.observable.subscribe(this.fetchNotifications);
    }

    componentWillUnmount() {
        NotificationService.stop();
        NotificationService.observable.unsubscribe(this.fetchNotifications);
    }

    render(props) {
        const purchased = ModuleInfoProvider.getModule('notification-store').purchased;
        if (!purchased) return null;

        const unreadBadge = () => this.state.unreadCount ? <SimpleBadge>{this.state.unreadCount}</SimpleBadge> : null;
        const notificationList = () => <NotificationList freeze={!this.state.open} onVisualized={this.fetchNotifications}/>;
        const buttonStyles = this.state.open ? {background: '#0079B8'} : {};

        return (
            <OutsideClickWrapper watch={this.state.open} onOutsideClick={this.toggleDropdown}>
                <SectionComponent>
                    <ToolbarButton onClick={this.toggleDropdown} title={translate('notification.list')} style={buttonStyles}>
                        <BellIcon/>{unreadBadge()}
                    </ToolbarButton>

                    <DropDownMenu open={this.state.open} closeFunction={this.toggleDropdown}>
                        {notificationList()}
                    </DropDownMenu>
                </SectionComponent>
            </OutsideClickWrapper>
        );
    }

    toggleDropdown = () => {
        this.setState({open: !this.state.open});
    };

    closeDropDown = () => {
        this.setState({open: false})
    };

    fetchNotifications = () => {
        this.setState({loading: true, error: false});
        const domain = ModuleInfoProvider.getModuleWebServiceUrl('notification-store');

        JWTClient.fetch(domain + '/api/v1/notification?visualized=0&limit=1')
            .then(res => {
                this.setState({
                    notifications: [],
                    loading: false,
                    error: false,
                    unreadCount: res.meta.pagination.total
                });
                NotificationService.badge(res.meta.pagination.total);
            })
            .catch((e) => {
                console.log(e);
                this.setState({loading: false, error: true, notifications: [], unreadCount: 0});
                NotificationService.badge(0);
            });
    }
}




// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/notification/notifications-button/index.js